import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { contextsApi } from "@/lib/api";
import type { DialplanContextCreate, DialplanContextUpdate } from "@/types";

export function useContexts() {
  return useQuery({
    queryKey: ["contexts"],
    queryFn: () => contextsApi.list(),
  });
}

export function useContext(id: string) {
  return useQuery({
    queryKey: ["contexts", id],
    queryFn: () => contextsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateContext() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: DialplanContextCreate) => contextsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["contexts"] }),
  });
}

export function useUpdateContext() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: DialplanContextUpdate;
    }) => contextsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["contexts"] }),
  });
}

export function useDeleteContext() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => contextsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["contexts"] }),
  });
}
